import React, { useState ,useEffect } from "react";
import {FaBoxOpen ,FaMoneyBillWave,FaTags,FaFileAlt ,FaListUl, FaUser,FaPhone, FaEnvelope, FaBuilding, FaMapMarkerAlt,  FaFileInvoice, FaImage,  FaIdCard, FaFilePdf,FaSearch,FaPlus,FaTimes
} from "react-icons/fa";

import axios from 'axios'
import toast from "react-hot-toast";
import Select from 'react-select';
import { Button, Card } from "react-bootstrap";


function Inventory({userData,token}) {
  

const [showForm, setShowForm] = useState(false);
  const [editingCompanyId, setEditingCompanyId] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);

 const [showStatusModal, setShowStatusModal] = useState(false);
const [selectedUser, setSelectedUser] = useState(null);
const [showKycModal, setShowKycModal] = useState(false);
const [selectedDealer, setSelectedDealer] = useState(null);
  const [showCategoryInput, setShowCategoryInput] = useState(false);
    const [showSubCategoryInput, setSubShowCategoryInput] = useState(false);

  const [newCategory, setNewCategory] = useState("");
    const [newSubCategory, setNewSubCategory] = useState("");
    
// const [images, setImages] = useState([]);
const[inventory,setInventory] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
const [categoryOptions, setCategoryOptions] = useState([]);

const [subCategoryOptions, setSubCategoryOptions] = useState([]);

const [newImages, setNewImages] = useState([]);
const [existingImages, setExistingImages] = useState([]);

const [showImageModal, setShowImageModal] = useState(false);
const [currentIndex, setCurrentIndex] = useState(0);
const [finalImages, setFinalImages] = useState([]);

const [deletedImages, setDeletedImages] = useState([]);
const [showActive, setShowActive] = useState(true);
// const [categoryOptionsFinal, setCategoryOptionsFinal] = useState([]);
    const[bussCat,setBussCat] = useState([]);


const [selectedCategory, setSelectedCategory] = useState("");
const [selectedSubCategory, setSelectedSubCategory] = useState("");
// const [categories, setCategories] = useState([]);
// const [subCategories, setSubCategories] = useState([]);


   const [categoryMaster, setCategoryMaster] = useState([]);
    const [formData, setFormData] = useState({
    name: "",
    mrp: "",
    sell_price: '',
    category: '',
    description: '',
      spec: "",
   imgs: null,
   added_by:'',
 sub_category: "",
  is_spare:0
  });

    const [extraFields, setExtraFields] = useState([
  { heading: "", description: "",  }
]);



  const handleInputChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "profile") {
      setFormData({ ...formData, [name]: files[0] });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };


const baseCategories = [
  { value: "Machine", label: "Machine" },
  { value: "Parts", label: "Parts" },
];

const baseSubCategories = [
  { value: "", label: "" },

];



const allCategories = [
  ...baseCategories,
  ...categoryOptions,
];

const subAllCategories = [
  ...baseSubCategories,
  ...subCategoryOptions,
];

const categoryOptionsFinal = [
  ...new Map(allCategories.map(item => [item.value, item])).values()
];

const subCategoryOptionsFinal = [
  ...new Map(subAllCategories.map(item => [item.value, item])).values()
];

  const handleAddRow = () => {

  setExtraFields([
    ...extraFields,
    { heading: "", description: "", }
  ]);
};

const handleRemoveRow = (index) => {
  const updated = extraFields.filter((_, i) => i !== index);
  setExtraFields(updated);
};


const handleExtraChange = (index, field, value) => {
  const updated = [...extraFields];
  updated[index][field] = value;
  setExtraFields(updated);
};





const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    const form = new FormData();

    form.append("name", formData.name);
    form.append("mrp", formData.mrp);
    form.append("sell_price", formData.sell_price);
    form.append("category", formData.category);
    form.append("sub_category", formData.sub_category);
    form.append("description", formData.description);
    form.append("added_by", userData.id);
   form.append("is_spare",formData.is_spare);
    // form.append("buss_name",formData.buss_name);

    const specData = extraFields
  .filter(
    (item) =>
      item.heading?.trim() || item.description?.trim()
  )
  .map((item, index) => ({
    id: index + 1,
    heading: item.heading.trim(),
    description: item.description.trim(),
  }));

form.append(
  "specs",
  specData.length ? JSON.stringify(specData) : ''
);

    const MAX_SIZE = 2 * 1024 * 1024;
    const MAX_IMAGES = 10;

    const finalImageCount = isEditMode
      ? existingImages.length + newImages.length
      : newImages.length;

    if (finalImageCount > MAX_IMAGES) {
      toast.error(`Maximum ${MAX_IMAGES} images are allowed.`);
      return;
    }

    for (const file of newImages) {
      if (file.size > MAX_SIZE) {
        toast.error("Each image must be less than 2MB!");
        return;
      }
    }

    // Upload new images
    newImages.forEach((file) => {
      form.append("images", file);
    });

    let res;

    if (isEditMode) {
      // Send comma-separated strings instead of JSON arrays
      form.append("existing_images", existingImages.join(","));
      form.append("deleted_images", deletedImages.join(","));

      res = await axios.put(
        `https://api.krimotion.in/update-inventory/${editingCompanyId}`,
        form,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      toast.success("Inventory updated successfully!");
    } else {
      res = await axios.post(
        "https://api.krimotion.in/add-inventory",
        form,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      toast.success("Inventory created successfully!");
    }

    resetForm();
    setShowForm(false);
    setNewImages([]);
    setExistingImages([]);
    setDeletedImages([]);
    setExtraFields([{ heading: "", description: "" }]);
    fetchInventory();
  } catch (error) {
    console.error(error);
    toast.error("Something went wrong!");
  }
};

const handleEdit = (item) => {
  setIsEditMode(true);
  setEditingCompanyId(item.id);

  setFormData({
    name: item.name || "",
    mrp: item.mrp || "",
    sell_price: item.sell_price || "",
    category: item.category || "",
    description: item.description || "",
    imgs: null,
    added_by: item.added_by || "",
      sub_category: item.sub_category || "",
      is_spare:item.is_spare || "",
        buss_name:item.buss_name || "",  
  });


  try {
    const parsedSpecs = item.specs ? JSON.parse(item.specs) : [];
    setExtraFields(parsedSpecs.length ? parsedSpecs : [{ heading: "", description: "" }]);
  } catch {
    setExtraFields([{ heading: "", description: "" }]);
  }


  try {
    // const parsedImages = item.imgs ? JSON.parse(item.imgs) : [];
    // setExistingImages(parsedImages);  

    const parsedImages = item.imgs
  ? item.imgs.split(",").filter(Boolean)
  : [];

setExistingImages(parsedImages);
  } catch {
    setExistingImages([]);
  }

  setNewImages([]); 
  setShowForm(true);
};



    const fetchInventory = async () => {
  try {
 const res = await axios.get(
  "https://api.krimotion.in/fetch-inventory",
  {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }
);

    const result = res.data;


    const filteredSorted = result.sort((a, b) => b.id - a.id);   

    setInventory(filteredSorted);


  const categoryList = result
  .map(item => item.category)
  .filter(Boolean)
  .map(cat => ({ value: cat, label: cat }));

setCategoryOptions(prev => {
  const merged = [...baseCategories, ...prev, ...categoryList];

  return [
    ...new Map(merged.map(item => [item.value, item])).values(),
  ];
  
});


const subCategoryList = result
  .map(item => item.sub_category)
  .filter(Boolean)
  .map(cat => ({
    value: cat,
    label: cat,
  }));

setSubCategoryOptions(prev => {
  const merged = [
    ...baseSubCategories,
    ...prev,
    ...subCategoryList,
  ];

  return [
    ...new Map(merged.map(item => [item.value, item])).values(),
  ];
});
   
  } catch (error) {
    console.log(error);
  }
};

   useEffect(() => {
    fetchInventory();
fetchMasterCategory();
fecthBusinesCat();
  }, []);

     const resetForm = () => {
  setFormData({
    name: "",
    mobile: "",
    email: "",
    address: "",
    buss_name: "",
    gst: "",

    profile: null,
    aadhaar_front: null,
    aadhaar_back: null,
    gst_doc: null,

    // ✅ IMPORTANT: reset previews also
    profilePreview: null,
    aadhaarFrontPreview: null,
    aadhaarBackPreview: null,
    gstDocPreview: null,
  });

  setIsEditMode(false);
  setEditingCompanyId(null);

    setExtraFields([{ heading: "", description: "" }]);
};




const categories = [
  ...new Set(
    inventory
      .map((item) => item.category)
      .filter((category) => category)
  ),
].map((category, index) => ({
  id: index,
  name: category,
}));



const subCategories = [
  ...new Set(
    inventory
      .filter(
        (item) =>
          !selectedCategory ||
          item.category === selectedCategory
      )
      .map((item) => item.sub_category)
      .filter((subCategory) => subCategory)
  ),
].map((subCategory, index) => ({
  id: index,
  name: subCategory,
}));

  const filteredData = Array.isArray(inventory)
  ? inventory.filter((itm) => {

      // SEARCH
      const matchesSearch = Object.values(itm).some((val) =>
        String(val)
          .toLowerCase()
          .includes(searchTerm.toLowerCase())
      );


      // CATEGORY
      const matchesCategory =
        !selectedCategory ||
        itm.category === selectedCategory;


      // SUB CATEGORY
      const matchesSubCategory =
        !selectedSubCategory ||
        itm.sub_category === selectedSubCategory;


      // ACTIVE / INACTIVE
      const matchesStatus =
        showActive
          ? Number(itm.is_active) === 1
          : Number(itm.is_active) === 0;


      return (
        matchesSearch &&
        matchesCategory &&
        matchesSubCategory &&
        matchesStatus
      );
    })
  : [];

    const handleStatusUpdate = async (user) => {
  try {
    const currentStatus = user.is_active;
    const newStatus = currentStatus === '1' ? '0' : '1';

    await axios.put(
      `https://api.krimotion.in/update-inventory-status/${user.id}`,
      {
        is_active: newStatus,
      },
       {
          headers: {
             Authorization: `Bearer ${token}`,
          },
        }
    );

    toast.success("Status updated successfully!");

    setShowStatusModal(false);
    fetchInventory(); 

  } catch (error) {
    console.log(error);
    toast.error("Failed to update status");
  }
};

const removeExistingImage = (img) => {

    setDeletedImages(prev => [...prev, img]);

    setExistingImages(prev =>
        prev.filter(image => image !== img)
    );

}


   const fetchMasterCategory = async () => {
    try {
      const res = await axios.get("https://api.krimotion.in/fetch-master-category",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      const result = res.data;
   

     setCategoryMaster(result);
       const options = result.map((item) => ({
      value: item.category,
      label: item.category,
    }));

    setCategoryOptions(options);
    } catch (error) {
      console.log(error);
    }
  };


//   const fetchMasterCategory = async () => {
//   try {
//     const res = await axios.get(
//       "https://api.krimotion.in/fetch-master-category",
//       {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       }
//     );

//     setCategoryMaster(res.data);

//   } catch (error) {
//     console.log(error);
//   }
// };


// useEffect(() => {
//   if (!formData.buss_name) {
//     setCategoryOptionsFinal([]);
//     return;
//   }

//   const filtered = categoryMaster.filter(
//     (item) => String(item.buss_name) === String(formData.buss_name)
//   );

//   const options = filtered.map((item) => ({
//     value: item.category,
//     label: item.category,
//   }));

//   setCategoryOptionsFinal(options);

// }, [formData.buss_name, categoryMaster]);



       const fecthBusinesCat = async () => {
    try {
      const res = await axios.get("https://api.krimotion.in/fetch-business-category",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      const result = res.data;

      setBussCat(result);
    } catch (error) {
      console.log(error);
    }
  };

    const businessOptions = bussCat.map((item) => ({
  value: item.id,
  label: item.buss_name,
}));


  return (
    <div className="container py-4">
   

<div className="border-0  mb-3 px-2 py-2  ">

  <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">

    {/* LEFT TITLE */}
    <div className="d-flex align-items-center">
      <h4 className="fw-bold mb-0" style={{ fontSize: "20px" }}>
        Manage Inventory
      </h4>
    </div>

    {/* CENTER SEARCH */}
<div style={{ flex: 1, maxWidth: "250px" }}>
  <div
    className="d-flex align-items-center rounded-pill overflow-hidden"
    style={{
      border: "1px solid var(--green)",
      height: "34px",
      paddingLeft: "8px",
      paddingRight: "8px",
      backgroundColor:'white'
    }}
  >
    {/* ICON */}
    <FaSearch
      style={{
        color: "var(--green)",
        fontSize: "14px",
        display: "flex",
        alignItems: "center"
      }}
    />

    {/* INPUT */}
    <input
      type="text"
      className="form-control border-0 shadow-none"
      placeholder="Search..."
      value={searchTerm}
      onChange={(e) => setSearchTerm(e.target.value)}
      style={{
        fontSize: "14px",
        height: "32px",
        marginLeft: "6px",
        lineHeight: "32px"
      }}
    />
  </div>
</div>

    {/* RIGHT BUTTON */}
    <div className="d-flex align-items-center">
      {!showForm ? (
        <button
          className="btn btn-sm px-3"
          onClick={() => setShowForm(true)}
          style={{
            backgroundColor: "var(--green)",
            color: "white",
            fontSize: "13px",
            height: "34px"
          }}
        >
          <FaPlus className="me-1" />
          Add Inventory
        </button>
      ) : (
        <button
          className="btn btn-danger btn-sm px-3"
          onClick={() => {
            resetForm();
            setShowForm(false);
          }}
          style={{ height: "34px", fontSize: "13px" }}
        >
          <FaTimes className="me-1" />
          Close
        </button>
      )}
    </div>

  </div>
</div>
         {/* Form */}
         {showForm && (
           <div className="card shadow-sm border-0 rounded-4 p-3">
   
   <form onSubmit={handleSubmit}> 
     <div className="row g-3">
   
   
     <div className="col-md-4">
       <label className="form-label fw-semibold">Item Name</label>
       <div className="input-group">
         <span className="input-group-text">
           <FaBoxOpen  />
         </span>
         <input
           type="text"
           className="form-control"
           placeholder="Enter  Name"
             name="name"
                     value={formData.name}
                     onChange={handleInputChange}
                     required
         />
       </div>
     </div>
   

     <div className="col-md-4">
       <label className="form-label fw-semibold">MRP</label>
       <div className="input-group">
         <span className="input-group-text">
           <FaTags  />
         </span>
         <input
           type="number"
           className="form-control"
           placeholder="Enter MRP"
             name="mrp"
                     value={formData.mrp}
                     onChange={handleInputChange}
                       required
         />
       </div>
     </div>

     <div className="col-md-4">
       <label className="form-label fw-semibold">Sell Price </label>
       <div className="input-group">
         <span className="input-group-text">
           <FaMoneyBillWave />
         </span>
         <input
           type="number"
           className="form-control"
           placeholder="Enter Sell price "
          name="sell_price"
                     value={formData.sell_price}
                     onChange={handleInputChange}  
                       required 
         />
       </div>
     </div>
   
   
    {/* <div className="col-md-4">
  <label className="form-label fw-semibold">
    Select Business Category
  </label>

  <div className="input-group">
  
    <Select
  options={businessOptions}
  placeholder="Select Business Category"
  value={
    businessOptions.find(
      (option) => option.value === formData.buss_name
    ) || null
  }
  onChange={(selectedOption) =>
    setFormData({
      ...formData,
      buss_name: selectedOption?.value || "",
        category: "",
    })
  }
  className="w-100"
/>
  </div>
</div>     */}
   
<div className="col-md-4">
  <label className="form-label fw-semibold">Category</label>
  

  <div className="d-flex align-items-center gap-2">
    <div className="flex-grow-1">
      <Select
   
        options={categoryOptionsFinal}
       
       value={
  categoryOptionsFinal.find(
    (opt) =>
      String(opt.value).trim().toLowerCase() ===
      String(formData.category).trim().toLowerCase()
  ) || null
}
        onChange={(selected) =>
          setFormData({
            ...formData,
            category: selected.value,
          })
        }
        placeholder="Select category"
        classNamePrefix="custom-select"
        required
      />

      {/* <Select
  options={categoryOptionsFinal}
  value={
    categoryOptionsFinal.find(
      (opt) => opt.value === formData.category
    ) || null
  }
  onChange={(selected) =>
    setFormData({
      ...formData,
      category: selected.value,
    })
  }
  placeholder="Select Category"
/> */}
    </div>


  </div>

  {showCategoryInput && (
    <div className="mt-2 d-flex gap-2">
      <input
        type="text"
        className="form-control"
        placeholder="New category"
        value={newCategory}
        onChange={(e) => setNewCategory(e.target.value)}
      />

      <Button
        variant="primary"
        onClick={() => {
          if (!newCategory.trim()) return;

          const newOption = {
            value: newCategory.trim(),
            label: newCategory.trim(),
          };

          setCategoryOptions([...categoryOptions, newOption]);
          setFormData({
            ...formData,
            category: newCategory.trim(),
          });

          setNewCategory("");
          setShowCategoryInput(false);
        }}
      >
        Save
      </Button>
    </div>
  )}
</div>

   <div className="col-md-4">
  <label className="form-label fw-semibold">Sub Category</label>
  

  <div className="d-flex align-items-center gap-2">
    <div className="flex-grow-1">
      <Select
   
        options={subCategoryOptionsFinal}
       
       value={
  subCategoryOptionsFinal.find(
    (opt) =>
      String(opt.value).trim().toLowerCase() ===
      String(formData.sub_category).trim().toLowerCase()
  ) || null
}
        onChange={(selected) =>
          setFormData({
            ...formData,
            sub_category: selected.value,
          })
        }
        placeholder="Select sub category"
        classNamePrefix="custom-select"
      />
    </div>

    <Button
      variant="success"
      onClick={() => setSubShowCategoryInput(true)}
       style={{backgroundColor:"var(--green)",color:'white'}}
    >
      +
    </Button>
  </div>

  {showSubCategoryInput && (
    <div className="mt-2 d-flex gap-2">
      <input
        type="text"
        className="form-control"
        placeholder="New category"
        value={newSubCategory}
        onChange={(e) => setNewSubCategory(e.target.value)}
      />

      <Button
        variant="primary"


        onClick={() => {
  if (!newSubCategory.trim()) return;

  const newOption = {
    value: newSubCategory.trim(),
    label: newSubCategory.trim(),
  };

  setSubCategoryOptions(prev => [...prev, newOption]);

  setFormData(prev => ({
    ...prev,
    sub_category: newSubCategory.trim(),
  }));

  setNewSubCategory("");
  setSubShowCategoryInput(false);
}}
      >
        Save
      </Button>
    </div>
  )}
</div>

<div className="col-md-4 d-flex align-items-center">
  <div className="form-check mt-4">

    <input
      className="form-check-input"
      type="checkbox"
      id="is_spare"
      checked={formData.is_spare === 1}
      onChange={(e) =>
        setFormData({
          ...formData,
          is_spare: e.target.checked ? 1 : 0,
        })
      }
    />

    <label
      className="form-check-label fw-semibold ms-2"
      htmlFor="is_spare"
    >
      Add As Spare Parts
    </label>

  </div>
</div>

   
 <div className="col-md-8">
       <label className="form-label fw-semibold">Description </label>
       <div className="input-group" >
         <span className="input-group-text"    style={{ height: "100px" }} >
           <FaFileAlt />
         </span>
      <textarea
      className="form-control"
      placeholder="Enter Description"
        style={{ height: "100px" }}
      name="description"
      value={formData.description}
      onChange={handleInputChange}
  
    />
       </div>
     </div>
   
   
  <div className="col-md-8">

  <div className="d-flex justify-content-between ">

<h4 
   className="fw-bold mb-0" style={{ fontSize: "19px" }}
   >
  Add Specific Field
</h4>
    <button
    type="button"
      className="btn-action btn-primary-custom"

      onClick={handleAddRow}
    >
      + Add More
    </button>
  </div>


    <div className="table-responsive ">
        <div className="card-body p-1">
               <table className="table table-bordered table-sm align-middle mb-0">

        <thead className="table table-dark">
          <tr>
            <th >Name</th>
            <th >Value</th>
            <th >Action</th>
          </tr>
        </thead>

        <tbody>
          {extraFields.map((row, index) => (
            <tr key={index}>

          
              <td >
                <input
                  type="text"
                  className="form-control table-input"
                  value={row.heading}
                  onChange={(e) =>
                    handleExtraChange(index, "heading", e.target.value)
                  }
                />
              </td>

        
              <td >
                <input
                  type="text"
                  className="form-control table-input"
                  value={row.description}
                  onChange={(e) =>
                    handleExtraChange(index, "description", e.target.value)
                  }
                />
              </td>

           

              <td >
                <button
                  className="btn btn-outline-danger btn-sm"
                  onClick={() => handleRemoveRow(index)}
                >
                  Remove
                </button>
              </td>

            </tr>
          ))}
        </tbody>

      </table>
        </div>

    </div>

 </div>   

  
   
        <div className="col-md-8">
       <label className="form-label fw-semibold">
         <FaImage className="me-2" />
        Upolad Image
       </label>
    
       <input
  type="file"
  className="form-control w-50"
  accept="image/*"
  multiple
 onChange={(e) => {
    setNewImages((prev) => [
      ...prev,
      ...Array.from(e.target.files),
    ]);
  }}
/>

{isEditMode && existingImages.length > 0 && (
  <div className="mb-3">
    <label className="fw-semibold">Existing Images</label>

 

    <div className="row g-3 mt-2">
  {existingImages.map((img, index) => (
    <div className="col-md-4" key={index}>
      <div className="position-relative">

          <a
          href={`https://api.krimotion.in/uploads/${img}`}
          target="_blank"
          rel="noopener noreferrer"
        >
                <img
          src={`https://api.krimotion.in/uploads/${img}`}
          className="img-fluid rounded border"
          style={{
            height: 120,
            width: "100%",
            objectFit: "cover"
          }}
        />

        </a>

  

        <button
          type="button"
          className="btn btn-danger btn-sm position-absolute top-0 end-0"
          onClick={() => removeExistingImage(img)}
        >
          ×
        </button>

      </div>
    </div>
  ))}
</div>
  </div>
)}
   
     </div>

  
   
     {/* Save Button */}
     <div className="col-12 text-end">
       <button type="submit" className="btn-action btn-success-custom"  style={{backgroundColor:"var(--green)",color:'white'}}>
        {isEditMode ? "Update  Item" : " Save Item "}
       </button>
     </div>
   
   </div>
   </form>
           </div>
         )}


{!showForm && (
  <>

<div className="d-flex justify-content-end align-items-center gap-2 flex-wrap mb-3">

<select
  className="form-select form-select-sm  w-auto"
  value={selectedCategory}
  onChange={(e) => {
    setSelectedCategory(e.target.value);

    setSelectedSubCategory("");
  }}
  style={{ width: "200px" }}
>
  <option value="">All Categories</option>

  {categories.map((cat) => (
    <option key={cat.id} value={cat.name}>
      {cat.name}
    </option>
  ))}
</select>

<select
  className="form-select form-select-sm  w-auto"
  value={selectedSubCategory}
  onChange={(e) => setSelectedSubCategory(e.target.value)}
  style={{ width: "200px" }}
  disabled={!selectedCategory}
>
  <option value="">All Sub Categories</option>

  {subCategories.map((sub) => (
    <option key={sub.id} value={sub.name}>
      {sub.name}
    </option>
  ))}
</select>
    
  <div
    className="d-flex align-items-center px-3 py-2 rounded-pill shadow-sm"
    style={{
      background: "#fff",
      border: "1px solid #e5e7eb",
      gap: "4px",
    }}
  >
    <span
      className={`fw-semibold ${
        showActive ? "text-success" : "text-danger"
      }`}
      style={{ minWidth: "100px" }}
    >
      {showActive ? "Active Items" : "Deactivated Items"}
    </span>

    <div className="form-check form-switch m-0">
      <input
        className="form-check-input"
        type="checkbox"
        checked={!showActive}
        onChange={() => setShowActive(!showActive)}
        style={{
          width: "3rem",
          height: "1.5rem",
          cursor: "pointer",
        }}
      />
    </div>
  </div>


</div>

  <div className="container-fluid mt-4">
    <div className="row g-4">

      {filteredData.map((user) => (

        <div className="col-xl-4 col-lg-4 col-md-6" key={user.id}>

          <div className="inventory-card d-flex flex-column h-100">

            {/* Top Section */}
            <div className="d-flex">

              <img
                src={
                  user.imgs
                    ? `https://api.krimotion.in/uploads/${user.imgs.split(",")[0]}`
                    : "https://via.placeholder.com/90x90?text=No+Image"
                }
                alt={user.name}
                className="inventory-image"
              />

              <div className="flex-grow-1 ms-3">

                <h5 className="inventory-title">
                  {user.name}
                </h5>

              </div>
            </div>

<div className="mt-2"> 
  <div className="inventory-row">
                  <span className="inventory-label">
                    Category:
                  </span>

                  <span>{user.category}</span>
                </div>

                <div className="inventory-row">
                  <span className="inventory-label">
                    MRP:
                  </span>

                  <span>₹ {user.mrp}</span>
                </div>

                <div className="inventory-row">
                  <span className="inventory-label">
                    Added By:
                  </span>

                  <span>{user.added_name}</span>
                </div>
  </div>

             

            {/* Bottom Section */}
        <div className="d-flex justify-content-between align-items-center mt-auto pt-3">

  <button
    className={`btn-action me-2 ${
      user.is_active == 1
        ? "btn-danger-custom"
        : "btn-success-custom"
    }`}
    onClick={() => {
      setSelectedUser(user);
      setShowStatusModal(true);
    }}
  >
    <i className="bi bi-pencil"></i>{" "}
    {user.is_active == 1 ? "Remove" : "Added"}
  </button>

  <button
    className="btn-action btn-primary-custom"
    onClick={() => handleEdit(user)}
  >
    Edit
  </button>

</div>

          </div>

        </div>

      ))}

    </div>
  </div>

    </>
)}

           {showImageModal && (
  <div className="modal d-block" style={{ background: "rgba(0,0,0,0.6)" }}>
    <div className="modal-dialog modal-dialog-centered">
      <div className="modal-content p-3 text-center">

        {/* Image */}
        <img
          src={`https://api.krimotion.in/uploads/${finalImages[currentIndex]}`}
          style={{ width: "100%", maxHeight: "400px", objectFit: "contain" }}
        />

        {/* Controls */}
        <div className="d-flex justify-content-between mt-3">

          <button
            className="btn btn-secondary"
            onClick={() =>
              setCurrentIndex((prev) =>
                prev === 0 ? finalImages.length - 1 : prev - 1
              )
            }
          >
            Prev
          </button>

          {/* DELETE BUTTON */}
          <button
            className="btn btn-danger"
            onClick={() => {
              const updated = finalImages.filter((_, i) => i !== currentIndex);

              setFinalImages(updated);

              if (currentIndex >= updated.length) {
                setCurrentIndex(0);
              }
            }}
          >
            Remove
          </button>

          <button
            className="btn btn-secondary"
            onClick={() =>
              setCurrentIndex((prev) =>
                prev === finalImages.length - 1 ? 0 : prev + 1
              )
            }
          >
            Next
          </button>

        </div>

        {/* Save + Close */}
        <div className="mt-3 d-flex justify-content-between">

          <button
            className="btn btn-success"
            onClick={() => {
              setExistingImages(finalImages);
              setShowImageModal(false);
            }}
          >
            Save Changes
          </button>

          <button
            className="btn btn-dark"
            onClick={() => setShowImageModal(false)}
          >
            Close
          </button>

        </div>

      </div>
    </div>
  </div>
)}


  {showStatusModal && (
  <div
    className="modal d-block"
    tabIndex="-1"
    style={{
      background: "rgba(15, 15, 15, 0.55)",
      backdropFilter: "blur(6px)",
    }}
  >
    <div className="modal-dialog modal-dialog-centered">
      <div
        className="modal-content border-0 rounded-4 shadow-lg"
        style={{
          overflow: "hidden",
        }}
      >

        {/* HEADER */}
        <div
          className="modal-header border-0"
          style={{
            background: "linear-gradient(135deg, var(--green), #0ea57a)",
            color: "white",
          }}
        >
          <h5 className="modal-title fw-semibold">
            Confirm Status Change
          </h5>

          <button
            className="btn-close btn-close-white"
            onClick={() => setShowStatusModal(false)}
          />
        </div>

        {/* BODY */}
        <div className="modal-body text-center p-4">

          <div
            style={{
              width: "70px",
              height: "70px",
              margin: "0 auto 15px",
              borderRadius: "50%",
              background:
                selectedUser?.is_active == "1"
                  ? "rgba(220, 53, 69, 0.1)"
                  : "rgba(25, 135, 84, 0.1)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "28px",
            }}
          >
            {selectedUser?.is_active == "1" ? "⚠️" : "✔️"}
          </div>

          <h5 className="fw-bold mb-2">
            {selectedUser?.is_active == "1"
              ? "Deactivate Item?"
              : "Activate Item?"}
          </h5>

          <p className="text-muted mb-2">
            You are about to change status for
          </p>

          <h6 className="fw-semibold text-dark mb-3">
            {selectedUser?.name}
          </h6>

          <div
            className="px-3 py-2 rounded-pill d-inline-block"
            style={{
              background:
                selectedUser?.is_active == "1"
                  ? "#ffe3e3"
                  : "#e6f7ee",
              color:
                selectedUser?.is_active == "1"
                  ? "#dc3545"
                  : "#198754",
              fontWeight: 600,
              fontSize: "13px",
            }}
          >
            Current Status:{" "}
            {selectedUser?.is_active == "1" ? "Active" : "Inactive"}
          </div>
        </div>

        {/* FOOTER */}
        <div className="modal-footer border-0 d-flex justify-content-center gap-2 pb-4">

          <button
            className="btn btn-light px-4 rounded-pill"
            onClick={() => setShowStatusModal(false)}
          >
            Cancel
          </button>

          <button
            className="btn px-4 rounded-pill text-white"
            style={{
              background:
                selectedUser?.is_active == "1"
                  ? "#dc3545"
                  : "var(--green)",
              boxShadow: "0 8px 20px rgba(0,0,0,0.15)",
            }}
            onClick={() => handleStatusUpdate(selectedUser)}
          >
            {selectedUser?.is_active == "1"
              ? "Deactivate"
              : "Activate"}
          </button>

        </div>

      </div>
    </div>
  </div>
)}

       
       </div>
  )
}

export default Inventory
